import * as React from "react";
import clsx from "clsx";
import { UseFormRegister, FieldErrors } from "react-hook-form";

interface OwnProps {
  name: string;
  label: string;
  helpText?: string;
  defaultValue?: boolean | null | undefined;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  type?: string;
}

export const CheckboxCustomFormField: React.FC<OwnProps> = (props) => {
  const errors = props.errors;
  const hasError = !!errors?.[props.name];
  const errorMessage = errors?.[props.name]?.message as string;

  return (
    <div className={clsx("form-check", { "has-error": hasError })}>
      <input
        className="form-check-input"
        type="checkbox"
        {...props.register(props.name as any)}
      />
      <label className="form-check-label">{props.label}</label>
      {hasError && (
        <span className="form-text text-danger">{errorMessage}</span>
      )}
      {props.helpText && (
        <small className="form-text text-muted">{props.helpText}</small>
      )}
    </div>
  );
};
